
import { useState, useEffect } from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavLogo } from './nav/NavLogo';
import { DesktopNav } from './nav/DesktopNav';
import { MobileMenuButton } from './nav/MobileMenuButton';
import { MobileNav } from './nav/MobileNav';

export function Navbar() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Change navbar style on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle logo click - navigate to home/news
  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo(0, 0);
  };

  // Helper function to determine if a route is active
  const isRouteActive = (path: string) => {
    return location.pathname === path;
  };

  // Close mobile menu when a link is clicked
  const handleMobileNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300 glass-navbar",
      isScrolled ? "py-2" : "py-3"
    )}>
      <div className="container px-2 sm:px-4 flex justify-between items-center">
        <NavLogo onLogoClick={handleLogoClick} />

        {/* Desktop navigation */}
        <DesktopNav isRouteActive={isRouteActive} />

        {/* Mobile menu button */}
        <MobileMenuButton
          isOpen={isMobileMenuOpen}
          onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        />
      </div>

      {/* Mobile menu */}
      <MobileNav
        isOpen={isMobileMenuOpen}
        isRouteActive={isRouteActive}
        onLinkClick={handleMobileNavLinkClick}
      />
    </header>
  );
}
